import { Exclude } from 'class-transformer/decorators';
import { IsDefined, IsIn, IsInt, IsISO8601, IsNumber, IsOptional, IsString, Length, Matches } from 'class-validator';
import { BankingPettyCashCategoryDto } from '../banking-petty-cash-category';
import { BankingSafeDto } from '../banking-safe';
import { BaseDto } from '../base.dto';
import { MerchantBriefDto } from '../merchant-brief.dto';
import { PosDeviceBriefDto } from '../pos-device-brief.dto';
import { UserBriefDto } from '../user-brief.dto';
import { validationPatterns } from '../../constants';

export class BankingPettyCashDto extends BaseDto {
  @IsDefined()
  @IsInt()
  merchantId: number;

  @IsOptional()
  @IsInt()
  bankingSafeCountHeaderId: number;

  @IsDefined()
  @IsString()
  @IsIn(['pos', 'safe'])
  transactionType: string;

  @IsOptional()
  @IsInt()
  posDeviceId: number;

  @IsOptional()
  @IsInt()
  employeeId?: number;

  @IsOptional()
  @IsInt()
  safeId: number;

  @IsDefined()
  @IsInt()
  pettyCashCategoryId: number;

  @IsDefined()
  @IsInt()
  approvedUserId: number;

  @IsDefined()
  @IsString()
  @IsISO8601()
  day: string;

  @IsDefined()
  @IsNumber({maxDecimalPlaces: 2})
  grossAmount: number;

  @IsDefined()
  @IsNumber({maxDecimalPlaces: 2})
  vatValue: number;

  @IsOptional()
  @IsString()
  @Length(0, 255)
  @Matches(validationPatterns.noteValidation)
  description: string;

  @IsOptional()
  @IsString()
  @Length(0, 255)
  photoUrl: string;

  @Exclude()
  deletedAt?: Date;

  @Exclude()
  merchant?: MerchantBriefDto;

  @Exclude()
  posDevice?: PosDeviceBriefDto;

  @Exclude()
  safe?: BankingSafeDto;

  @Exclude()
  pettyCashCategory?: BankingPettyCashCategoryDto;

  @Exclude()
  approvedUser?: UserBriefDto;

  @Exclude()
  lastModifiedUser?: UserBriefDto
}
